import * as React from 'react';
import { connect } from 'react-redux';
import '../css/SuperUserPageView.css';
import { TooltipCont } from '../../../infrastructure/tooltips';
import { getScrollbarWidth } from '../../../lib/helpers';
import { ITechReferenceSheet, ITechReferenceSheetType } from '../../../infrastructure/interfaces'
import { getAgronomyReferenceSheets, toggleAgronomyReferenceSheetPublish, createAgronomyReferenceSheet, editAgronomyReferenceSheet} from '../../../actions/actions'
import HeaderBar from '../../HeaderBar/HeaderBar';
import AgronomyReferenceSheetCreatorModal from '../../Modals/AgronomyReferenceSheetCreatorModal/AgronomyReferenceSheetCreatorModal'
import { contentImagesRelativePath } from '../../../constants';

export interface IManageAgronomyReferenceProps {
  agronomyReferenceSheets?: ITechReferenceSheet[];
  toggleAgronomyReferenceSheetPublish(agronomyReferenceSheet: ITechReferenceSheet): void;
  createAgronomyReferenceSheet(agronomyReferenceSheetName: string, agronomyReferenceSheetType: ITechReferenceSheetType, formData: FormData): void;
  editAgronomyReferenceSheet(agronomyReferenceSheetName: string, agronomyReferenceSheetType: ITechReferenceSheetType, formData: FormData, sheetToEdit: ITechReferenceSheet): void;
  getAgronomyReferenceSheets(): void;
  onCreate(): void;
}

export interface IManageAgronomyReferenceState {
  selectedAgronomyReferenceSheet?: ITechReferenceSheet;
  showAgronomyReferenceSheetCreatorModal: Boolean
}

const mapStateToProps = (state: any) => {
  return {
    agronomyReferenceSheets: state.agronomyReferenceSheetList,
  };
};

const mapDispatchToProps = (dispatch: any): any => {
  return {
    getAgronomyReferenceSheets: () => {
      dispatch(getAgronomyReferenceSheets());
    },
    toggleAgronomyReferenceSheetPublish: (agronomyReferenceSheet: ITechReferenceSheet) => {
      dispatch(toggleAgronomyReferenceSheetPublish(agronomyReferenceSheet));
    },
    createAgronomyReferenceSheet: (agronomyReferenceSheetName: string, agronomyReferenceSheetType: ITechReferenceSheetType, formData: FormData) => {
      dispatch(createAgronomyReferenceSheet(agronomyReferenceSheetName, agronomyReferenceSheetType, formData));
    },
    editAgronomyReferenceSheet: (agronomyReferenceSheetName: string, agronomyReferenceSheetType: ITechReferenceSheetType, formData: FormData, sheetToEdit: ITechReferenceSheet) => {
      dispatch(editAgronomyReferenceSheet(agronomyReferenceSheetName, agronomyReferenceSheetType, formData, sheetToEdit))
    }
  };
};

@(connect(mapStateToProps, mapDispatchToProps) as any)
export default class ManageAgronomyReferenceSheetsTable extends React.Component<IManageAgronomyReferenceProps, IManageAgronomyReferenceState> {
  tableRow: HTMLElement;
  constructor(props: IManageAgronomyReferenceProps) {
    super(props);
    this.state = {
      showAgronomyReferenceSheetCreatorModal: false
    };

    // Bind methods
    this.closeModals = this.closeModals.bind(this)
    this.createAgronomyReferenceSheet = this.createAgronomyReferenceSheet.bind(this)
  }

  componentDidMount() {
    this.props.getAgronomyReferenceSheets();
  }

  onCreateAgronomyReferenceSheet() {
    this.setState({
        showAgronomyReferenceSheetCreatorModal: true,
        selectedAgronomyReferenceSheet: undefined,
    });
  }

  onEditAgronomyReferenceSheet = (sheet: ITechReferenceSheet) => {
    this.setState({
        selectedAgronomyReferenceSheet: sheet,
    }, () => {
      this.setState({
        showAgronomyReferenceSheetCreatorModal: true,
      })
    });
  }

  ontoggleAgronomyReferenceSheetPublish(agronomyReferenceSheet: ITechReferenceSheet) {
    if( agronomyReferenceSheet ) {
      this.toggleAgronomyReferenceSheetPublish(agronomyReferenceSheet);
    }
  }

  toggleAgronomyReferenceSheetPublish(agronomyReferenceSheet: ITechReferenceSheet) {
    this.props.toggleAgronomyReferenceSheetPublish(agronomyReferenceSheet)
  }

  createAgronomyReferenceSheet(agronomyReferenceSheetName: string, agronomyReferenceSheetType: ITechReferenceSheetType, formData: FormData) {
    this.props.createAgronomyReferenceSheet(agronomyReferenceSheetName, agronomyReferenceSheetType, formData)
  }
  
  editAgronomyReferenceSheet(agronomyReferenceSheetName: string,
                              agronomyReferenceSheetType: ITechReferenceSheetType,
                              formData: FormData,
                              sheetToEdit: ITechReferenceSheet) {
    this.props.editAgronomyReferenceSheet(agronomyReferenceSheetName, agronomyReferenceSheetType, formData, sheetToEdit);
  }

  closeModals() {
    this.setState({
      showAgronomyReferenceSheetCreatorModal: false,
      selectedAgronomyReferenceSheet: undefined
    });
  }

  render() {

    const {
      agronomyReferenceSheets,
    } = this.props;
    var nonNullagronomyReferenceSheets = agronomyReferenceSheets ? agronomyReferenceSheets : [];

    return (
      <div className="root-container">
        <HeaderBar />
        <div className="inner-su-container">
          <div className="manage-items-row-offsetRight">

            <div className="in-row-text-container">
              Manage Sustainability and Agronomy Sheets
            </div>
            <div className="in-row-button-container">
              <button
                className="btn primary-green large"
                onClick={() => this.onCreateAgronomyReferenceSheet()}
                title={TooltipCont.CREATE_AGRONOMY_SHEET}
              >
                Upload Reference/Tech Sheet
              </button>
            </div>
          </div>
          <table className="table-scrollableSU documents-table">
            <thead style={{ paddingRight: getScrollbarWidth() }}>
              <tr>
                <th>Name</th>
                <th>Category</th>
                <th>Image</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody className="document-table-body">
              {nonNullagronomyReferenceSheets.map((ars: ITechReferenceSheet) =>
                <tr key={ars.id} ref={tr => this.tableRow = tr!}>
                  <td>
                      {ars.title}
                  </td>
                  <td>
                      {ars.sheet_category}
                  </td>
                  <td>
                    <img className="inlineImagesTableImage" src={contentImagesRelativePath + ars.src} />
                  </td>
                  <td>
                    <div className="button-wrapper">
                    <button
                        className="btn primary-blue"
                        onClick={() => this.onEditAgronomyReferenceSheet(ars)}
                        title={TooltipCont.EDIT}
                        disabled={false}
                      >
                        Edit
                      </button>
                      <button
                        className="btn primary-blue"
                        onClick={() => this.ontoggleAgronomyReferenceSheetPublish(ars)}
                        title={TooltipCont.PUBLISH}
                        disabled={false}
                      >
                        {ars.published ? "Unpublish" : "Publish"}
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <AgronomyReferenceSheetCreatorModal
          show={this.state.showAgronomyReferenceSheetCreatorModal}
          onClose={this.closeModals}
          onSubmit={(agronomyReferenceSheetName: string,
                      agronomyReferenceSheetType: ITechReferenceSheetType,
                      formData: FormData,
                      sheetToEdit: ITechReferenceSheet | undefined) => {
            if (sheetToEdit != undefined) {
              this.editAgronomyReferenceSheet(agronomyReferenceSheetName, agronomyReferenceSheetType, formData, sheetToEdit);
            } else {
              this.createAgronomyReferenceSheet(agronomyReferenceSheetName, agronomyReferenceSheetType, formData);
            }
            this.closeModals();
          }}
          sheetToEdit={this.state.selectedAgronomyReferenceSheet}
        />
      </div>);
  }
}



// WEBPACK FOOTER //
// ./src/components/SuperUser/components/ManageAgronomyReferenceSheets.tsx